import * as angular from 'angular';

import { IFileManagementService, ILoggerService } from '../../services';
import { Directory } from '../../models/Directory';
import { ComponentDefinition, IFileInformation } from '../../models';

class FilePickerController implements angular.IComponentController, angular.IOnChanges {
    applicationGuid: string;
    directory: string;
    extensions: string;
    fileContent: string;
    files: IFileInformation[];
    formController: any;
    id: string;
    isLoading = false;
    isModalOpen = false;
    label: string;
    onOk: (value: { fileName: string }) => void;
    selectedFile: any;
    selectedFilename: string;
    fileList: FileList;

    static $inject = ['$scope', 'fileManagementService', 'loggerService'];

    constructor(
        private _$scope: angular.IScope,
        private _fileManagementService: IFileManagementService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        this.refresh();

        this._$scope.$watch(() => this.fileList, () => {
            this.upload(this.fileList);
        });
        this._$scope.$watch(() => this.applicationGuid, () => {
            this.refresh();
        });
        this._$scope.$watch(() => this.directory, () => {
            this.refresh();
        });
        if (!this.extensions) {
            this.extensions = 'image/*,.pdf';
        }
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        if (onChangesObj['extensions']) {
            if (!this.extensions) {
                this.extensions = 'image/*,.pdf';
            }
        }
    }

    private refresh(): angular.IPromise<any> {
        const promise = this._fileManagementService.getContent(this.applicationGuid);
        return promise
            .then((data: Directory) => {
                const relativePath = this.getRelativePath();
                const dir = this.getDir(this.directory, data.directories);
                this.files = dir ? dir.files : data.files;
                this.files.forEach(f => f.parent = { relativePath: relativePath } as Directory);
                if (this.fileContent) {
                    const found = this.files.find(f => this.fileContent.indexOf(f.name) >= 0);
                    this.selectedFile = found;
                } else {
                    this.selectedFile = null;
                }
            });
    }

    private getDir(path: string, directories: Directory[]): Directory {
        let dir: Directory;
        const pathPieces = path.split('/');
        pathPieces.forEach(p => {
            dir = directories.find(d => d.name.toLowerCase() === p.toLowerCase());
            if (dir) {
                directories = dir.directories;
            }
        });
        return dir;
    }

    select(file) {
        this.selectedFile = file;
    }

    validate() {
        this.fileContent = this.selectedFile ? `${this.directory}/${this.selectedFile.name}` : '';
        if (this.onOk) {
            this.onOk({ fileName: this.fileContent });
        }
    }

    upload(newFile: FileList) {
        if (newFile && newFile.length) {
            const self = this;
            this.isLoading = true;
            this._fileManagementService
                .upload(newFile[0], this.getRelativePath(), undefined, this.applicationGuid)
                .then(_data => {
                    return this.refresh();
                })
                .then(() => {
                    this.selectedFile = this.files.find(f => f.name === newFile[0].name);
                })
                .catch(reason => self._loggerService.logError('File cannot be uploaded', true, '', reason))
                .finally(() => {
                    this.isLoading = false;
                    this.fileList = undefined;
                });
        }
    }

    getRelativePath(): string {
        return `Content/${this.directory}/`;
    }

    openModal() {
        this.isModalOpen = true;
    }

    closeModal() {
        this.isModalOpen = false;
    }
}

export const wtFilePicker: ComponentDefinition = {
    componentId: 'wtFilePicker',
    transclude: true,
    controller: FilePickerController,
    template: require('./filePicker.component.html'),
    controllerAs: 'vm',
    bindings: {
        id: '@',
        label: '@',
        selectedFilename: '=',
        directory: '@',
        extensions: '<?',
        fileContent: '=?',
        applicationGuid: '<',
        onOk: '&?'
    }
};